const logger = require('./utils/logger');
const { redactCredentials } = require('./utils/redactCredentials');

const FINANCIAL_ERROR_CODES = Object.freeze({
  PREPARATION: '00-FSP-000',
  PREPARATION_DEPENDENCY: '00-FSP-001',
  PREPARATION_ENROLLMENT: '00-FSP-002',
  PREPARATION_COLLEGE: '00-FSP-003',
  PREPARATION_EMPLOYER: '00-FSP-004',
  PREPARATION_INPUTS: '00-FSP-005',
  PREPARATION_CONTEXT: '00-FSP-006',
  SAVINGS_LOOKUP: '00-ARS-000',
  NAVIGATION: '00-FSN-000',
  SUBMISSION: '00-FSH-000',
  SUBMISSION_CONTEXT: '00-FSH-001',
  SUBMISSION_CALCULATOR: '00-FSH-002',
  SUBMISSION_PREFERENCES: '00-FSH-003',
  SUBMISSION_APPLICATION: '00-FSH-004',
  SUBMISSION_SUMMARY: '00-FSH-005',
  SUBMISSION_TASK: '00-FSH-006',
  SUBMISSION_ASSOCIATIONS: '00-FSH-007',
  INPUTS: '00-FSI-000',
});
const isMappedErrorCode = value => typeof value === 'string'
  && /^(?:\d{2}-\d{5}-\d{3}|\d{3}-\d{3}|00-[A-Z]+-\d{3}|ERR_[A-Z_]+|E[A-Z]{3,})$/.test(value);
const SENTINEL_ERROR_CODES = Object.freeze({
  'No Email found': '02-21037-404',
  'No Address found': '02-21036-404',
  'No Phone found': '02-21038-404',
  'No Phone Consent found': '02-21039-404',
  'Navigation Error': '03-21011-000',
  'triggerAlloyTrack error': '00-TAT-000',
  'triggerAlloyPageView error': '00-TAPV-000',
  'applicationSectionInfo Error': '00-ASI-000',
  'postApplication analytics Error': '00-PAA-000',
  esiError: '00-ESI-000',
});
const sentinelErrorCode = error => (typeof error === 'string'
  && Object.prototype.hasOwnProperty.call(SENTINEL_ERROR_CODES, error)
  ? SENTINEL_ERROR_CODES[error] : undefined);
// This is a patch to allow this code to be reused in the server.
// Can be refactored later, for not the functions calling the FS methods
// Are already not being used by the server.
const fullStoryUpdater = {
  sendCustomFullStoryEvent: () => { },
};
if ((typeof window !== 'undefined') && window) {
  const {
    sendCustomFullStoryEvent,
    // eslint-disable-next-line global-require
  } = require('./modules/vendor/fullstory/FullStoryUpdater');
  fullStoryUpdater.sendCustomFullStoryEvent = sendCustomFullStoryEvent;
}
const {
  REACT_APP_FORGE_ROCK_BASE_URL,
} = process.env;

const methodToCode = method => {
  switch (method) {
    case 'delete':
      return '01';
    case 'get':
      return '02';
    case 'post':
      return '03';
    case 'put':
      return '04';
    default:
      return '00';
  }
};

/**
 * Convert Domain and Subdomains to Code
 * @param {*} domain
 * @param {*} url
 */
// TODO: Ensure all calls in the app are covered. (I.E. Wallets, work, etc)
const domainToDigits = (domain, url) => {
  switch (domain) {
    case 'applications':
      if (url.indexOf('navigation') >= 0) {
        return '011';
      }
      return '010';
    case 'catalogs':
      return '020';
    case 'contacts':
      if (url.indexOf('validate') >= 0) {
        if (url.indexOf('zipcode') >= 0) {
          return '032';
        }
        if (url.indexOf('address') >= 0) {
          return '033';
        }
        return '031';
      }
      if (url.indexOf('suggest') >= 0) {
        if (url.indexOf('address') >= 0) {
          return '035';
        }
        return '034';
      }
      if (url.indexOf('address') >= 0) {
        return '036';
      }
      if (url.indexOf('email') >= 0) {
        return '037';
      }
      if (url.indexOf('phone') >= 0) {
        return '038';
      }
      if (url.indexOf('consent') >= 0) {
        return '039';
      }
      return '030';
    case 'courses':
      return '040';
    case 'iam':
      if (url.indexOf('email') >= 0) {
        return '051';
      }
      if (url.indexOf('username') >= 0) {
        return '052';
      }
      return '050';
    case 'learning':
      return '060';
    case 'organizations':
      if (url.indexOf('military') >= 0) {
        return '072';
      }
      if (url.indexOf('veranorg') >= 0) {
        return '072';
      }
      return '070';
    case 'persons':
      if (url.indexOf('names') >= 0) {
        return '081';
      }
      if (url.indexOf('name') >= 0) {
        return '082';
      }
      if (url.indexOf('information') >= 0) {
        return '083';
      }
      if (url.indexOf('education') >= 0) {
        if (url.indexOf('higher') >= 0) {
          return '085';
        }
        if (url.indexOf('secondary') >= 0) {
          return '086';
        }
        return '084';
      }
      if (url.indexOf('exams') >= 0) {
        return '087';
      }
      if (url.indexOf('military') >= 0) {
        return '088';
      }
      if (url.indexOf('employment') >= 0) {
        return '089';
      }
      return '080';
    case 'preferences':
      return '090';
    case 'programs':
      if (url.indexOf('programDetail') >= 0) {
        return '101';
      }
      if (url.indexOf('programOfferings') >= 0) {
        return '102';
      }
      return '100';
    case 'sagas':
      if (url.indexOf('humantasks') >= 0) {
        return '111';
      }
      if (url.indexOf('workflow/ADMISSION/person') >= 0) {
        return '112';
      }
      if (url.indexOf('workflow') >= 0) {
        return '113';
      }
      if (url.indexOf('/tasks') >= 0) {
        return '114';
      }
      return '110';
    case 'students':
      return '120';
    case 'wallet':
    case 'wallets':
      return '130';
    case 'financialaid':
      return '140';
    case 'document':
      if (url.indexOf('task') >= 0) {
        return '151';
      }
      if (url.indexOf('sign') >= 0) {
        return '152';
      }
      if (url.indexOf('signDocument') >= 0) {
        return '153';
      }
      if (url.indexOf('cleanupForms') >= 0) {
        return '154';
      }
      if (url.indexOf('adobe') >= 0) {
        return '155';
      }
      if (url.indexOf('submitTasks') >= 0) {
        return '156';
      }
      if (url.indexOf('attachments') >= 0) {
        return '157';
      }
      return '150';
    case 'documents':
      return '160';
    case 'dgsp':
      return '170';
    default:
      return '000';
  }
};

const urlToCode = url => {
  // eslint-disable-next-line no-underscore-dangle
  const basePath = (typeof window !== 'undefined' && window.__ENV && window.__ENV.REACT_APP_BASE_PATH)
    // eslint-disable-next-line no-underscore-dangle
    ? window.__ENV.REACT_APP_BASE_PATH
    : (process.env.BASE_PATH || '/application');
  const urlParts = url.split('/');
  if (url.indexOf(`${basePath}/`) >= 0) { // PROXY Request 2XXXX
    switch (urlParts[2]) {
      case 'api':
        return `21${domainToDigits(urlParts[3], url)}`;
      case 'cas':
        return '22000';
      case 'csrf':
        return '23000';
      default:
        return '20000';
    }
  }
  if (url.indexOf('/api/') >= 0) { // API Request 10XXX
    return `10${domainToDigits(urlParts[2], url)}`;
  }
  if (url.indexOf(REACT_APP_FORGE_ROCK_BASE_URL) >= 0) { // FORGE ROCK REQUEST
    return '30000';
  }
  return '00000'; // OTHER
};

const jsErrorToCode = error => {
  if (isMappedErrorCode(error.mappedErrorCode)) return error.mappedErrorCode;
  if (Object.values(FINANCIAL_ERROR_CODES).includes(error.code)) return error.code;
  const errorType = error.name;
  let errorTypeCode = '';
  let errorMessageCode = '';
  switch (errorType) {
    case 'EvalError':
      errorTypeCode = '001';
      break;
    case 'InternalError':
      errorTypeCode = '002';
      break;
    case 'RangeError':
      errorTypeCode = '003';
      break;
    case 'ReferenceError':
      errorTypeCode = '004';
      break;
    case 'SyntaxError':
      errorTypeCode = '005';
      break;
    case 'TypeError':
      errorTypeCode = '006';
      break;
    case 'URIError':
      errorTypeCode = '007';
      break;
    case 'Error':
      errorTypeCode = '008';
      break;
    case 'MissingData':
      errorTypeCode = '009';
      break;
    default:
      errorTypeCode = '000';
  }

  // TODO: Extend this with more conditons of expected JS errors
  if (error.message.includes('Cannot read propert') && error.message.includes('length')) {
    errorMessageCode = '001';
  } else if (error.message.includes('Cannot read propert')
    && error.message.includes('of undefined')) {
    errorMessageCode = '002';
  } else if (error.message.includes('\'undefined\' is not an object')) {
    errorMessageCode = '003';
  } else if (error.message.includes('\'null\' is not an object')) {
    errorMessageCode = '004';
  } else if (error.message.includes('Object doesn\'t support property or method')) {
    errorMessageCode = '005';
  } else if (error.message.includes('is not a function')) {
    errorMessageCode = '006';
  } else if (error.message.includes('Maximum call stack size exceeded')) {
    errorMessageCode = '007';
  } else if (error.message.includes('Cannot set propert')
    && error.message.includes('of undefined')) {
    errorMessageCode = '008';
  } else if (error.message.includes('is not defined')) {
    errorMessageCode = '009';
  } else if (error.message.includes('Network Error')) {
    errorMessageCode = '010';
  } else if (error.message.includes('No financial plan id')) {
    errorMessageCode = '011';
  } else if (error.message.includes('No apply web id')) {
    errorMessageCode = '012';
  } else {
    errorMessageCode = '000';
  }

  return `${errorTypeCode}-${errorMessageCode}`;
};

const PIIBlacklist = [
  'wallets',
  'iam',
];

const isPII = url => {
  let isBlocked = false;
  if (url) {
    PIIBlacklist.forEach(blacklistedUrl => {
      if (url.includes(blacklistedUrl)) {
        isBlocked = true;
      }
    });
  }

  return isBlocked;
};

const handleRequestError = error => {
  const { config = {}, response = {}, code = '' } = (error || {});
  let errorCode;
  const sentinelCode = sentinelErrorCode(error);
  if (sentinelCode) {
    errorCode = sentinelCode;
  } else {
    const requestMethod = (config.method || '').toLowerCase();
    const requestUrl = config.url ? config.url.toLowerCase() : '';
    // Normalize axios timeout-style errors into the existing request error code format.
    if (code === 'ECONNABORTED' || code === 'ETIMEDOUT') {
      errorCode = `${methodToCode(requestMethod)}-${urlToCode(requestUrl)}-${response.status || (error && error.status) || '408'}`;
    } else {
      errorCode = code || `${methodToCode(requestMethod)}-${urlToCode(requestUrl)}-${response.status || (error && error.status) || '000'}`;
    }
  }
  const requestId = config.headers ? `\nREQUEST ID: ${config.headers['X-Request-Id']}` : '';
  const correlationId = `\nCORRELATION ID: ${config.headers ? config.headers['X-Correlation-Id'] : sessionStorage.getItem('X-Correlation-Id')}`;
  const shouldDataBeBlocked = isPII(config.url);

  const event = redactCredentials({
    requestId,
    correlationId,
    isPII: shouldDataBeBlocked,
    errorCode,
    requestUrl: config.url,
    requestMethod: config.method,
    requestBody: shouldDataBeBlocked || config.data ? {} : JSON.stringify(config.data),
    requestResponse: response,
  });
  if (shouldDataBeBlocked && event.requestResponse?.config) {
    delete event.requestResponse.config.data;
  }
  fullStoryUpdater.sendCustomFullStoryEvent('REQUEST_ERROR', event);

  return errorCode;
};

const handleJsError = error => {
  logger.debug('Javascript error stack trace', error);
  const errorCode = jsErrorToCode(error);

  fullStoryUpdater.sendCustomFullStoryEvent('JAVASCRIPT_ERROR', redactCredentials({
    errorCode,
    errorMessage: error.message,
    errorStackTrace: error.stack,
  }));

  return errorCode;
};

const errorToMessage = error => {
  let errorCode;
  try {
    if (error && error.message && !error.response && !error.config) {
      errorCode = handleJsError(error);
    } else {
      errorCode = handleRequestError(error);
    }
  } catch {
    errorCode = '000-500';
  }
  return errorCode;
};

const errorsToMessages = errors => {
  const errorCodes = [];
  errors.forEach(error => {
    const dataError = error.errorData;
    try {
      if (dataError && dataError.message && !dataError.response && !dataError.config) {
        errorCodes.push(handleJsError(dataError));
      } else {
        errorCodes.push(handleRequestError(dataError));
      }
    } catch {
      errorCodes.push('000-500');
    }
  });
  return errorCodes;
};

const errorToMessageNode = (method, url, status, headers) => {
  const requestId = headers ? `REQUEST ID: ${headers['x-request-id']}` : '';
  const correlationId = headers ? `CORRELATION ID: ${headers['x-correlation-id']}` : '';
  const errorMessage = `${methodToCode(method)}-${urlToCode(url ? url.toLowerCase() : '')}-${status || ''} ${requestId}  ${correlationId}`;
  return errorMessage;
};

module.exports = {
  errorToMessage,
  errorsToMessages,
  errorToMessageNode,
  urlToCode,
  FINANCIAL_ERROR_CODES,
  isMappedErrorCode,
  sentinelErrorCode,
};
